export default "__VITE_ASSET__BaqLhN8A__"